import { useEffect } from "react"
import { centerAfterZoom, MAX_WHEEL_ZOOM, MIN_WHEEL_ZOOM, NEW_WHEEL_STATE, nextWheel, wheelDelta } from "lib/map"

// Mouse wheel zoom of a Google map, step by step. The built-in wheel zoom of Google Maps is
// turned off (`scrollwheel: false` in the map options) and replaced by this one: one level per
// notch of the wheel, at most a few levels per second, towards the mouse cursor. See nextWheel
// in lib/map.js for the rules.
export const useSmoothWheelZoom = (map) => {
  useEffect(() => {
    if (!map) return undefined
    const element = map.getDiv()
    let state = NEW_WHEEL_STATE

    const onWheel = (event) => {
      // The page must not zoom or scroll while the cursor is over the map
      event.preventDefault()
      event.stopPropagation()

      const result = nextWheel(state, wheelDelta(event), performance.now())
      state = result.state
      if (!result.step) return

      const zoom = map.getZoom()
      const nextZoom = zoom + result.step
      if (nextZoom < MIN_WHEEL_ZOOM || nextZoom > MAX_WHEEL_ZOOM) return

      const box = element.getBoundingClientRect()
      const center = map.getCenter()
      const target = centerAfterZoom({
        center: { lat: center.lat(), lng: center.lng() },
        zoom,
        nextZoom,
        size: { width: box.width, height: box.height },
        cursor: { x: event.clientX - box.left, y: event.clientY - box.top },
      })
      map.setOptions({ zoom: nextZoom, center: target })
    }

    // Capture phase and not passive: the event is stopped before Google Maps or the page see it
    element.addEventListener("wheel", onWheel, { passive: false, capture: true })
    return () => element.removeEventListener("wheel", onWheel, { capture: true })
  }, [map])
}
